module.exports = __webpack_public_path__ + "static/media/crockery.642d0a45.jpeg";